export default function checkOutsideURL(url) {
  const { host } = window.location;

  return url.indexOf(host) === -1;
}
